import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { FieldArray } from '~src/settings/FormikWrapperForStubbing';
import { cssClass } from '~src/style';

import { Cluster } from '../types/Cluster';
import { DataConnectMultiClusterTableEntryCluster } from './DataConnectMultiClusterTableEntryCluster';
import { DataConnectMultiClusterTableEntryNodes } from './DataConnectMultiClusterTableEntryNodes';
import { ExpandClusterButton } from './ExpandClusterButton';

export type DataConnectMultiClusterTableBodyProps = Readonly<{
  clusters: Record<string, Cluster>;
  existingClusterNames: ReadonlyArray<string>;
  refreshPoolsAndClusters: () => void;
}>;

export function DataConnectMultiClusterTableBody(props: DataConnectMultiClusterTableBodyProps) {
  const [expandedRowIndex, setExpandedRowIndex] = React.useState(-1);

  const clusters: ReadonlyArray<Cluster> = Object.values(props.clusters);

  if (clusters.length === 0) {
    return renderNoClustersWarning();
  }

  return (
    <FieldArray
      name={''}
      render={() => (
        clusters.map((cluster: Cluster, index) => (
          <tbody key={index}>
            <tr>
              <ExpandClusterButton
                isExpanded={expandedRowIndex === index}
                setExpanded={(expand: boolean) => setExpandedRowIndex(expand ? index : -1)}
                isDisabled={false}
              />
              <DataConnectMultiClusterTableEntryCluster
                cluster={cluster}
                existingClusterNames={props.existingClusterNames}
                isExpanded={expandedRowIndex === index}
                allowEditDisplayName={cluster.allowEditDisplayName}
                allowGetContainerRegistry={cluster.allowGetContainerRegistry}
                allowDeleteCluster={cluster.allowDeleteCluster}
                allowShareCluster={cluster.allowShareCluster}
                refreshPoolsAndClusters={props.refreshPoolsAndClusters}
              />
            </tr>
            {(expandedRowIndex === index) &&
              <tr className={focusClass}>
                <td className={'tb-data-grid-separator-row'} style={{borderBottom: 0}} />
                <td colSpan={7}>
                  <DataConnectMultiClusterTableEntryNodes
                    nodes={Object.values(cluster.nodes)}
                    nodesResUsage={cluster.nodesResUsage}
                    nodesAlerts={cluster.nodesAlerts}
                    clusterId={cluster.clusterId}
                    clusterName={cluster.clusterName}
                    allowRejectNode={cluster.allowRejectNode}
                    allowDeleteNode={cluster.allowDeleteNode}
                    allowApproveNode={cluster.allowApproveNode}
                    refreshPoolsAndClusters={props.refreshPoolsAndClusters}
                  />
                </td>
              </tr>}
          </tbody>))
      )}
    />
  );
}

function renderNoClustersWarning() {
  return (
    <tbody>
      <tr>
        <td colSpan={9}>
          <div className={'tb-data-grid-cell-text tb-data-grid-DataConnect-center'}>
            {Messages.dataConnectSiteSettingsClusterNotFoundWarning()}
          </div>
        </td>
      </tr>
    </tbody>);
}

const focusClass = cssClass('MultiPool', 'expanded-focus', {
  background: 'transparent',
});
